module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_End.8daf3cd5.mp3";